/* tslint:disable */
/* eslint-disable */
/**
 * bi-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrganizationUsersSyncResponse
 */
export interface OrganizationUsersSyncResponse {
    /**
     * 
     * @type {string}
     * @memberof OrganizationUsersSyncResponse
     */
    status: OrganizationUsersSyncResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof OrganizationUsersSyncResponse
     */
    active_source?: OrganizationUsersSyncResponseActiveSourceEnum;
    /**
     * 
     * @type {boolean}
     * @memberof OrganizationUsersSyncResponse
     */
    can_start_manually: boolean;
    /**
     * 
     * @type {Date}
     * @memberof OrganizationUsersSyncResponse
     */
    next_allowed_manual_sync_at?: Date;
    /**
     * 
     * @type {Date}
     * @memberof OrganizationUsersSyncResponse
     */
    next_retry_at?: Date;
    /**
     * 
     * @type {number}
     * @memberof OrganizationUsersSyncResponse
     */
    job_id?: number;
    /**
     * 
     * @type {number}
     * @memberof OrganizationUsersSyncResponse
     */
    last_finished_job_id?: number;
    /**
     * 
     * @type {string}
     * @memberof OrganizationUsersSyncResponse
     */
    last_result?: OrganizationUsersSyncResponseLastResultEnum;
    /**
     * 
     * @type {string}
     * @memberof OrganizationUsersSyncResponse
     */
    last_result_source?: OrganizationUsersSyncResponseLastResultSourceEnum;
    /**
     * 
     * @type {boolean}
     * @memberof OrganizationUsersSyncResponse
     */
    manual_sync_started?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OrganizationUsersSyncResponse
     */
    manual_sync_queued?: boolean;
}


/**
 * @export
 */
export const OrganizationUsersSyncResponseStatusEnum = {
    idle: 'idle',
    queued: 'queued',
    running: 'running'
} as const;
export type OrganizationUsersSyncResponseStatusEnum = typeof OrganizationUsersSyncResponseStatusEnum[keyof typeof OrganizationUsersSyncResponseStatusEnum];

/**
 * @export
 */
export const OrganizationUsersSyncResponseActiveSourceEnum = {
    manual: 'manual',
    scheduled: 'scheduled',
    transfer: 'transfer'
} as const;
export type OrganizationUsersSyncResponseActiveSourceEnum = typeof OrganizationUsersSyncResponseActiveSourceEnum[keyof typeof OrganizationUsersSyncResponseActiveSourceEnum];

/**
 * @export
 */
export const OrganizationUsersSyncResponseLastResultEnum = {
    completed: 'completed',
    failed: 'failed'
} as const;
export type OrganizationUsersSyncResponseLastResultEnum = typeof OrganizationUsersSyncResponseLastResultEnum[keyof typeof OrganizationUsersSyncResponseLastResultEnum];

/**
 * @export
 */
export const OrganizationUsersSyncResponseLastResultSourceEnum = {
    manual: 'manual',
    scheduled: 'scheduled',
    transfer: 'transfer'
} as const;
export type OrganizationUsersSyncResponseLastResultSourceEnum = typeof OrganizationUsersSyncResponseLastResultSourceEnum[keyof typeof OrganizationUsersSyncResponseLastResultSourceEnum];


/**
 * Check if a given object implements the OrganizationUsersSyncResponse interface.
 */
export function instanceOfOrganizationUsersSyncResponse(value: object): value is OrganizationUsersSyncResponse {
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('can_start_manually' in value) || value['can_start_manually'] === undefined) return false;
    return true;
}

export function OrganizationUsersSyncResponseFromJSON(json: any): OrganizationUsersSyncResponse {
    return OrganizationUsersSyncResponseFromJSONTyped(json, false);
}

export function OrganizationUsersSyncResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationUsersSyncResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'],
        'active_source': json['active_source'] == null ? undefined : json['active_source'],
        'can_start_manually': json['can_start_manually'],
        'next_allowed_manual_sync_at': json['next_allowed_manual_sync_at'] == null ? undefined : (new Date(json['next_allowed_manual_sync_at'])),
        'next_retry_at': json['next_retry_at'] == null ? undefined : (new Date(json['next_retry_at'])),
        'job_id': json['job_id'] == null ? undefined : json['job_id'],
        'last_finished_job_id': json['last_finished_job_id'] == null ? undefined : json['last_finished_job_id'],
        'last_result': json['last_result'] == null ? undefined : json['last_result'],
        'last_result_source': json['last_result_source'] == null ? undefined : json['last_result_source'],
        'manual_sync_started': json['manual_sync_started'] == null ? undefined : json['manual_sync_started'],
        'manual_sync_queued': json['manual_sync_queued'] == null ? undefined : json['manual_sync_queued'],
    };
}

export function OrganizationUsersSyncResponseToJSON(json: any): OrganizationUsersSyncResponse {
    return OrganizationUsersSyncResponseToJSONTyped(json, false);
}

export function OrganizationUsersSyncResponseToJSONTyped(value?: OrganizationUsersSyncResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': value['status'],
        'active_source': value['active_source'],
        'can_start_manually': value['can_start_manually'],
        'next_allowed_manual_sync_at': value['next_allowed_manual_sync_at'] == null ? undefined : ((value['next_allowed_manual_sync_at']).toISOString()),
        'next_retry_at': value['next_retry_at'] == null ? undefined : ((value['next_retry_at']).toISOString()),
        'job_id': value['job_id'],
        'last_finished_job_id': value['last_finished_job_id'],
        'last_result': value['last_result'],
        'last_result_source': value['last_result_source'],
        'manual_sync_started': value['manual_sync_started'],
        'manual_sync_queued': value['manual_sync_queued'],
    };
}

